import { render, staticRenderFns } from "./GUploader.vue?vue&type=template&id=272f488e&scoped=true&"
import script from "./GUploader.vue?vue&type=script&lang=js&"
export * from "./GUploader.vue?vue&type=script&lang=js&"
import style0 from "./GUploader.vue?vue&type=style&index=0&id=272f488e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f488e",
  null
  
)

export default component.exports